import { useRequiredContext } from "@redotech/react-util/context";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { ReturnsAndClaimsPermissions } from "@redotech/redo-model/permissions";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo, useContext } from "react";
import { useMatch } from "react-router-dom";
import {
  OrderManagementSuiteStatusesContext,
  WITHDRAWAL_ICON,
  WITHDRAWAL_ICON_FILLED,
} from "../../../../redo-suite/order-management-cloud";

const WithdrawalItemContent = memo(function WithdrawalItemContent() {
  const routes = useRequiredContext(MerchantRoutesContext);

  const withdrawalMatch = useMatch(`${routes.getWithdrawalHref()}/*`);
  const anyChildSelected = !!withdrawalMatch;

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.getWithdrawalHref() }}
      anyChildSelected={anyChildSelected}
      FilledIcon={WITHDRAWAL_ICON_FILLED}
      friendlyName="Withdrawals"
      id="withdrawal"
      UnfilledIcon={WITHDRAWAL_ICON}
    >
      <RedoSecondaryNavItem
        action={{
          type: "link",
          href: routes.getWithdrawalSubRoute("all-withdrawals"),
        }}
        friendlyName="All withdrawals"
        id="all-withdrawals"
      />
      <RedoSecondaryNavItem
        action={{
          type: "link",
          href: routes.getWithdrawalSubRoute("needs-action"),
        }}
        friendlyName="Needs action"
        id="withdrawal-needs-action"
      />
    </RedoSecondaryNavItem>
  );
});

export const WithdrawalItem = memo(function WithdrawalItem() {
  const hasPermissionToViewItem = useHasPermission(
    ReturnsAndClaimsPermissions.MANAGE_WITHDRAWAL_REQUESTS,
  );
  const { withdrawalEnabled } = useContext(OrderManagementSuiteStatusesContext);

  if (!hasPermissionToViewItem || !withdrawalEnabled) {
    return null;
  }

  return <WithdrawalItemContent />;
});
